/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './rutas/__root'
import { Route as IndexRouteImport } from './rutas/index'
import { Route as ActivosFijosRouteImport } from './rutas/activos-fijos'
import { Route as BancosRouteImport } from './rutas/bancos'
import { Route as ClientesRouteImport } from './rutas/clientes'
import { Route as ComprasRouteImport } from './rutas/compras'
import { Route as ConfiguracionRouteImport } from './rutas/configuracion'
import { Route as ConsolaRouteImport } from './rutas/consola'
import { Route as ContabilidadRouteImport } from './rutas/contabilidad'
import { Route as ContadorRouteImport } from './rutas/contador'
import { Route as CuentasPorCobrarRouteImport } from './rutas/cuentas-por-cobrar'
import { Route as CuentasPorPagarRouteImport } from './rutas/cuentas-por-pagar'
import { Route as DespachoRouteImport } from './rutas/despacho'
import { Route as DocumentosRouteImport } from './rutas/documentos'
import { Route as EmitirRouteImport } from './rutas/emitir'
import { Route as EmpleadoRouteImport } from './rutas/empleado'
import { Route as EntregasRouteImport } from './rutas/entregas'
import { Route as GastosRouteImport } from './rutas/gastos'
import { Route as ImportacionRouteImport } from './rutas/importacion'
import { Route as InicioRouteImport } from './rutas/inicio'
import { Route as InteligenciaArtificialRouteImport } from './rutas/inteligencia-artificial'
import { Route as NominaRouteImport } from './rutas/nomina'
import { Route as PagosRouteImport } from './rutas/pagos'
import { Route as ProductosRouteImport } from './rutas/productos'
import { Route as RecibidosRouteImport } from './rutas/recibidos'
import { Route as ReportesRouteImport } from './rutas/reportes'
import { Route as SistemaRouteImport } from './rutas/sistema'
import { Route as SuscripcionRouteImport } from './rutas/suscripcion'
import { Route as WebhooksRouteImport } from './rutas/webhooks'
import { Route as ConsolaIndexRouteImport } from './rutas/consola/index'
import { Route as ConsolaAuditoriaRouteImport } from './rutas/consola/auditoria'
import { Route as ConsolaEntrarRouteImport } from './rutas/consola/entrar'
import { Route as ConsolaFallidosRouteImport } from './rutas/consola/fallidos'
import { Route as ConsolaMorososRouteImport } from './rutas/consola/morosos'
import { Route as DespachoIndexRouteImport } from './rutas/despacho/index'
import { Route as DespachoAuditoriaRouteImport } from './rutas/despacho/auditoria'
import { Route as DespachoClientesRouteImport } from './rutas/despacho/clientes'
import { Route as DespachoCuentaRouteImport } from './rutas/despacho/cuenta'
import { Route as DespachoEquipoRouteImport } from './rutas/despacho/equipo'
import { Route as EmpleadoIndexRouteImport } from './rutas/empleado/index'
import { Route as EmpleadoAccesoRouteImport } from './rutas/empleado/acceso'
import { Route as SistemaIndexRouteImport } from './rutas/sistema/index'
import { Route as SistemaFormulariosRouteImport } from './rutas/sistema/formularios'
import { Route as SistemaRetroalimentacionRouteImport } from './rutas/sistema/retroalimentacion'
import { Route as SistemaSuperposicionesRouteImport } from './rutas/sistema/superposiciones'
import { Route as SistemaTablaRouteImport } from './rutas/sistema/tabla'
import { Route as ConsolaClientesIndexRouteImport } from './rutas/consola/clientes/index'
import { Route as ConsolaClientesIdRouteImport } from './rutas/consola/clientes/$id'
import { Route as ConsolaDespachosIndexRouteImport } from './rutas/consola/despachos/index'
import { Route as ConsolaDespachosIdRouteImport } from './rutas/consola/despachos/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivosFijosRoute = ActivosFijosRouteImport.update({
  id: '/activos-fijos',
  path: '/activos-fijos',
  getParentRoute: () => rootRouteImport,
} as any)
const BancosRoute = BancosRouteImport.update({
  id: '/bancos',
  path: '/bancos',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientesRoute = ClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => rootRouteImport,
} as any)
const ComprasRoute = ComprasRouteImport.update({
  id: '/compras',
  path: '/compras',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguracionRoute = ConfiguracionRouteImport.update({
  id: '/configuracion',
  path: '/configuracion',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsolaRoute = ConsolaRouteImport.update({
  id: '/consola',
  path: '/consola',
  getParentRoute: () => rootRouteImport,
} as any)
const ContabilidadRoute = ContabilidadRouteImport.update({
  id: '/contabilidad',
  path: '/contabilidad',
  getParentRoute: () => rootRouteImport,
} as any)
const ContadorRoute = ContadorRouteImport.update({
  id: '/contador',
  path: '/contador',
  getParentRoute: () => rootRouteImport,
} as any)
const CuentasPorCobrarRoute = CuentasPorCobrarRouteImport.update({
  id: '/cuentas-por-cobrar',
  path: '/cuentas-por-cobrar',
  getParentRoute: () => rootRouteImport,
} as any)
const CuentasPorPagarRoute = CuentasPorPagarRouteImport.update({
  id: '/cuentas-por-pagar',
  path: '/cuentas-por-pagar',
  getParentRoute: () => rootRouteImport,
} as any)
const DespachoRoute = DespachoRouteImport.update({
  id: '/despacho',
  path: '/despacho',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentosRoute = DocumentosRouteImport.update({
  id: '/documentos',
  path: '/documentos',
  getParentRoute: () => rootRouteImport,
} as any)
const EmitirRoute = EmitirRouteImport.update({
  id: '/emitir',
  path: '/emitir',
  getParentRoute: () => rootRouteImport,
} as any)
const EmpleadoRoute = EmpleadoRouteImport.update({
  id: '/empleado',
  path: '/empleado',
  getParentRoute: () => rootRouteImport,
} as any)
const EntregasRoute = EntregasRouteImport.update({
  id: '/entregas',
  path: '/entregas',
  getParentRoute: () => rootRouteImport,
} as any)
const GastosRoute = GastosRouteImport.update({
  id: '/gastos',
  path: '/gastos',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportacionRoute = ImportacionRouteImport.update({
  id: '/importacion',
  path: '/importacion',
  getParentRoute: () => rootRouteImport,
} as any)
const InicioRoute = InicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => rootRouteImport,
} as any)
const InteligenciaArtificialRoute = InteligenciaArtificialRouteImport.update({
  id: '/inteligencia-artificial',
  path: '/inteligencia-artificial',
  getParentRoute: () => rootRouteImport,
} as any)
const NominaRoute = NominaRouteImport.update({
  id: '/nomina',
  path: '/nomina',
  getParentRoute: () => rootRouteImport,
} as any)
const PagosRoute = PagosRouteImport.update({
  id: '/pagos',
  path: '/pagos',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductosRoute = ProductosRouteImport.update({
  id: '/productos',
  path: '/productos',
  getParentRoute: () => rootRouteImport,
} as any)
const RecibidosRoute = RecibidosRouteImport.update({
  id: '/recibidos',
  path: '/recibidos',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportesRoute = ReportesRouteImport.update({
  id: '/reportes',
  path: '/reportes',
  getParentRoute: () => rootRouteImport,
} as any)
const SistemaRoute = SistemaRouteImport.update({
  id: '/sistema',
  path: '/sistema',
  getParentRoute: () => rootRouteImport,
} as any)
const SuscripcionRoute = SuscripcionRouteImport.update({
  id: '/suscripcion',
  path: '/suscripcion',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksRoute = WebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsolaIndexRoute = ConsolaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaAuditoriaRoute = ConsolaAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaEntrarRoute = ConsolaEntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaFallidosRoute = ConsolaFallidosRouteImport.update({
  id: '/fallidos',
  path: '/fallidos',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaMorososRoute = ConsolaMorososRouteImport.update({
  id: '/morosos',
  path: '/morosos',
  getParentRoute: () => ConsolaRoute,
} as any)
const DespachoIndexRoute = DespachoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DespachoRoute,
} as any)
const DespachoAuditoriaRoute = DespachoAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => DespachoRoute,
} as any)
const DespachoClientesRoute = DespachoClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => DespachoRoute,
} as any)
const DespachoCuentaRoute = DespachoCuentaRouteImport.update({
  id: '/cuenta',
  path: '/cuenta',
  getParentRoute: () => DespachoRoute,
} as any)
const DespachoEquipoRoute = DespachoEquipoRouteImport.update({
  id: '/equipo',
  path: '/equipo',
  getParentRoute: () => DespachoRoute,
} as any)
const EmpleadoIndexRoute = EmpleadoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EmpleadoRoute,
} as any)
const EmpleadoAccesoRoute = EmpleadoAccesoRouteImport.update({
  id: '/acceso',
  path: '/acceso',
  getParentRoute: () => EmpleadoRoute,
} as any)
const SistemaIndexRoute = SistemaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SistemaRoute,
} as any)
const SistemaFormulariosRoute = SistemaFormulariosRouteImport.update({
  id: '/formularios',
  path: '/formularios',
  getParentRoute: () => SistemaRoute,
} as any)
const SistemaRetroalimentacionRoute =
  SistemaRetroalimentacionRouteImport.update({
    id: '/retroalimentacion',
    path: '/retroalimentacion',
    getParentRoute: () => SistemaRoute,
  } as any)
const SistemaSuperposicionesRoute = SistemaSuperposicionesRouteImport.update({
  id: '/superposiciones',
  path: '/superposiciones',
  getParentRoute: () => SistemaRoute,
} as any)
const SistemaTablaRoute = SistemaTablaRouteImport.update({
  id: '/tabla',
  path: '/tabla',
  getParentRoute: () => SistemaRoute,
} as any)
const ConsolaClientesIndexRoute = ConsolaClientesIndexRouteImport.update({
  id: '/clientes/',
  path: '/clientes/',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaClientesIdRoute = ConsolaClientesIdRouteImport.update({
  id: '/clientes/$id',
  path: '/clientes/$id',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaDespachosIndexRoute = ConsolaDespachosIndexRouteImport.update({
  id: '/despachos/',
  path: '/despachos/',
  getParentRoute: () => ConsolaRoute,
} as any)
const ConsolaDespachosIdRoute = ConsolaDespachosIdRouteImport.update({
  id: '/despachos/$id',
  path: '/despachos/$id',
  getParentRoute: () => ConsolaRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activos-fijos': typeof ActivosFijosRoute
  '/bancos': typeof BancosRoute
  '/clientes': typeof ClientesRoute
  '/compras': typeof ComprasRoute
  '/configuracion': typeof ConfiguracionRoute
  '/consola': typeof ConsolaRouteWithChildren
  '/contabilidad': typeof ContabilidadRoute
  '/contador': typeof ContadorRoute
  '/cuentas-por-cobrar': typeof CuentasPorCobrarRoute
  '/cuentas-por-pagar': typeof CuentasPorPagarRoute
  '/despacho': typeof DespachoRouteWithChildren
  '/documentos': typeof DocumentosRoute
  '/emitir': typeof EmitirRoute
  '/empleado': typeof EmpleadoRouteWithChildren
  '/entregas': typeof EntregasRoute
  '/gastos': typeof GastosRoute
  '/importacion': typeof ImportacionRoute
  '/inicio': typeof InicioRoute
  '/inteligencia-artificial': typeof InteligenciaArtificialRoute
  '/nomina': typeof NominaRoute
  '/pagos': typeof PagosRoute
  '/productos': typeof ProductosRoute
  '/recibidos': typeof RecibidosRoute
  '/reportes': typeof ReportesRoute
  '/sistema': typeof SistemaRouteWithChildren
  '/suscripcion': typeof SuscripcionRoute
  '/webhooks': typeof WebhooksRoute
  '/consola/auditoria': typeof ConsolaAuditoriaRoute
  '/consola/entrar': typeof ConsolaEntrarRoute
  '/consola/fallidos': typeof ConsolaFallidosRoute
  '/consola/morosos': typeof ConsolaMorososRoute
  '/despacho/auditoria': typeof DespachoAuditoriaRoute
  '/despacho/clientes': typeof DespachoClientesRoute
  '/despacho/cuenta': typeof DespachoCuentaRoute
  '/despacho/equipo': typeof DespachoEquipoRoute
  '/empleado/acceso': typeof EmpleadoAccesoRoute
  '/sistema/formularios': typeof SistemaFormulariosRoute
  '/sistema/retroalimentacion': typeof SistemaRetroalimentacionRoute
  '/sistema/superposiciones': typeof SistemaSuperposicionesRoute
  '/sistema/tabla': typeof SistemaTablaRoute
  '/consola/': typeof ConsolaIndexRoute
  '/despacho/': typeof DespachoIndexRoute
  '/empleado/': typeof EmpleadoIndexRoute
  '/sistema/': typeof SistemaIndexRoute
  '/consola/clientes/$id': typeof ConsolaClientesIdRoute
  '/consola/despachos/$id': typeof ConsolaDespachosIdRoute
  '/consola/clientes/': typeof ConsolaClientesIndexRoute
  '/consola/despachos/': typeof ConsolaDespachosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activos-fijos': typeof ActivosFijosRoute
  '/bancos': typeof BancosRoute
  '/clientes': typeof ClientesRoute
  '/compras': typeof ComprasRoute
  '/configuracion': typeof ConfiguracionRoute
  '/contabilidad': typeof ContabilidadRoute
  '/contador': typeof ContadorRoute
  '/cuentas-por-cobrar': typeof CuentasPorCobrarRoute
  '/cuentas-por-pagar': typeof CuentasPorPagarRoute
  '/documentos': typeof DocumentosRoute
  '/emitir': typeof EmitirRoute
  '/entregas': typeof EntregasRoute
  '/gastos': typeof GastosRoute
  '/importacion': typeof ImportacionRoute
  '/inicio': typeof InicioRoute
  '/inteligencia-artificial': typeof InteligenciaArtificialRoute
  '/nomina': typeof NominaRoute
  '/pagos': typeof PagosRoute
  '/productos': typeof ProductosRoute
  '/recibidos': typeof RecibidosRoute
  '/reportes': typeof ReportesRoute
  '/suscripcion': typeof SuscripcionRoute
  '/webhooks': typeof WebhooksRoute
  '/consola/auditoria': typeof ConsolaAuditoriaRoute
  '/consola/entrar': typeof ConsolaEntrarRoute
  '/consola/fallidos': typeof ConsolaFallidosRoute
  '/consola/morosos': typeof ConsolaMorososRoute
  '/despacho/auditoria': typeof DespachoAuditoriaRoute
  '/despacho/clientes': typeof DespachoClientesRoute
  '/despacho/cuenta': typeof DespachoCuentaRoute
  '/despacho/equipo': typeof DespachoEquipoRoute
  '/empleado/acceso': typeof EmpleadoAccesoRoute
  '/sistema/formularios': typeof SistemaFormulariosRoute
  '/sistema/retroalimentacion': typeof SistemaRetroalimentacionRoute
  '/sistema/superposiciones': typeof SistemaSuperposicionesRoute
  '/sistema/tabla': typeof SistemaTablaRoute
  '/consola': typeof ConsolaIndexRoute
  '/despacho': typeof DespachoIndexRoute
  '/empleado': typeof EmpleadoIndexRoute
  '/sistema': typeof SistemaIndexRoute
  '/consola/clientes/$id': typeof ConsolaClientesIdRoute
  '/consola/despachos/$id': typeof ConsolaDespachosIdRoute
  '/consola/clientes': typeof ConsolaClientesIndexRoute
  '/consola/despachos': typeof ConsolaDespachosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activos-fijos': typeof ActivosFijosRoute
  '/bancos': typeof BancosRoute
  '/clientes': typeof ClientesRoute
  '/compras': typeof ComprasRoute
  '/configuracion': typeof ConfiguracionRoute
  '/consola': typeof ConsolaRouteWithChildren
  '/contabilidad': typeof ContabilidadRoute
  '/contador': typeof ContadorRoute
  '/cuentas-por-cobrar': typeof CuentasPorCobrarRoute
  '/cuentas-por-pagar': typeof CuentasPorPagarRoute
  '/despacho': typeof DespachoRouteWithChildren
  '/documentos': typeof DocumentosRoute
  '/emitir': typeof EmitirRoute
  '/empleado': typeof EmpleadoRouteWithChildren
  '/entregas': typeof EntregasRoute
  '/gastos': typeof GastosRoute
  '/importacion': typeof ImportacionRoute
  '/inicio': typeof InicioRoute
  '/inteligencia-artificial': typeof InteligenciaArtificialRoute
  '/nomina': typeof NominaRoute
  '/pagos': typeof PagosRoute
  '/productos': typeof ProductosRoute
  '/recibidos': typeof RecibidosRoute
  '/reportes': typeof ReportesRoute
  '/sistema': typeof SistemaRouteWithChildren
  '/suscripcion': typeof SuscripcionRoute
  '/webhooks': typeof WebhooksRoute
  '/consola/auditoria': typeof ConsolaAuditoriaRoute
  '/consola/entrar': typeof ConsolaEntrarRoute
  '/consola/fallidos': typeof ConsolaFallidosRoute
  '/consola/morosos': typeof ConsolaMorososRoute
  '/despacho/auditoria': typeof DespachoAuditoriaRoute
  '/despacho/clientes': typeof DespachoClientesRoute
  '/despacho/cuenta': typeof DespachoCuentaRoute
  '/despacho/equipo': typeof DespachoEquipoRoute
  '/empleado/acceso': typeof EmpleadoAccesoRoute
  '/sistema/formularios': typeof SistemaFormulariosRoute
  '/sistema/retroalimentacion': typeof SistemaRetroalimentacionRoute
  '/sistema/superposiciones': typeof SistemaSuperposicionesRoute
  '/sistema/tabla': typeof SistemaTablaRoute
  '/consola/': typeof ConsolaIndexRoute
  '/despacho/': typeof DespachoIndexRoute
  '/empleado/': typeof EmpleadoIndexRoute
  '/sistema/': typeof SistemaIndexRoute
  '/consola/clientes/$id': typeof ConsolaClientesIdRoute
  '/consola/despachos/$id': typeof ConsolaDespachosIdRoute
  '/consola/clientes/': typeof ConsolaClientesIndexRoute
  '/consola/despachos/': typeof ConsolaDespachosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activos-fijos'
    | '/bancos'
    | '/clientes'
    | '/compras'
    | '/configuracion'
    | '/consola'
    | '/contabilidad'
    | '/contador'
    | '/cuentas-por-cobrar'
    | '/cuentas-por-pagar'
    | '/despacho'
    | '/documentos'
    | '/emitir'
    | '/empleado'
    | '/entregas'
    | '/gastos'
    | '/importacion'
    | '/inicio'
    | '/inteligencia-artificial'
    | '/nomina'
    | '/pagos'
    | '/productos'
    | '/recibidos'
    | '/reportes'
    | '/sistema'
    | '/suscripcion'
    | '/webhooks'
    | '/consola/auditoria'
    | '/consola/entrar'
    | '/consola/fallidos'
    | '/consola/morosos'
    | '/despacho/auditoria'
    | '/despacho/clientes'
    | '/despacho/cuenta'
    | '/despacho/equipo'
    | '/empleado/acceso'
    | '/sistema/formularios'
    | '/sistema/retroalimentacion'
    | '/sistema/superposiciones'
    | '/sistema/tabla'
    | '/consola/'
    | '/despacho/'
    | '/empleado/'
    | '/sistema/'
    | '/consola/clientes/$id'
    | '/consola/despachos/$id'
    | '/consola/clientes/'
    | '/consola/despachos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activos-fijos'
    | '/bancos'
    | '/clientes'
    | '/compras'
    | '/configuracion'
    | '/contabilidad'
    | '/contador'
    | '/cuentas-por-cobrar'
    | '/cuentas-por-pagar'
    | '/documentos'
    | '/emitir'
    | '/entregas'
    | '/gastos'
    | '/importacion'
    | '/inicio'
    | '/inteligencia-artificial'
    | '/nomina'
    | '/pagos'
    | '/productos'
    | '/recibidos'
    | '/reportes'
    | '/suscripcion'
    | '/webhooks'
    | '/consola/auditoria'
    | '/consola/entrar'
    | '/consola/fallidos'
    | '/consola/morosos'
    | '/despacho/auditoria'
    | '/despacho/clientes'
    | '/despacho/cuenta'
    | '/despacho/equipo'
    | '/empleado/acceso'
    | '/sistema/formularios'
    | '/sistema/retroalimentacion'
    | '/sistema/superposiciones'
    | '/sistema/tabla'
    | '/consola'
    | '/despacho'
    | '/empleado'
    | '/sistema'
    | '/consola/clientes/$id'
    | '/consola/despachos/$id'
    | '/consola/clientes'
    | '/consola/despachos'
  id:
    | '__root__'
    | '/'
    | '/activos-fijos'
    | '/bancos'
    | '/clientes'
    | '/compras'
    | '/configuracion'
    | '/consola'
    | '/contabilidad'
    | '/contador'
    | '/cuentas-por-cobrar'
    | '/cuentas-por-pagar'
    | '/despacho'
    | '/documentos'
    | '/emitir'
    | '/empleado'
    | '/entregas'
    | '/gastos'
    | '/importacion'
    | '/inicio'
    | '/inteligencia-artificial'
    | '/nomina'
    | '/pagos'
    | '/productos'
    | '/recibidos'
    | '/reportes'
    | '/sistema'
    | '/suscripcion'
    | '/webhooks'
    | '/consola/auditoria'
    | '/consola/entrar'
    | '/consola/fallidos'
    | '/consola/morosos'
    | '/despacho/auditoria'
    | '/despacho/clientes'
    | '/despacho/cuenta'
    | '/despacho/equipo'
    | '/empleado/acceso'
    | '/sistema/formularios'
    | '/sistema/retroalimentacion'
    | '/sistema/superposiciones'
    | '/sistema/tabla'
    | '/consola/'
    | '/despacho/'
    | '/empleado/'
    | '/sistema/'
    | '/consola/clientes/$id'
    | '/consola/despachos/$id'
    | '/consola/clientes/'
    | '/consola/despachos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivosFijosRoute: typeof ActivosFijosRoute
  BancosRoute: typeof BancosRoute
  ClientesRoute: typeof ClientesRoute
  ComprasRoute: typeof ComprasRoute
  ConfiguracionRoute: typeof ConfiguracionRoute
  ConsolaRoute: typeof ConsolaRouteWithChildren
  ContabilidadRoute: typeof ContabilidadRoute
  ContadorRoute: typeof ContadorRoute
  CuentasPorCobrarRoute: typeof CuentasPorCobrarRoute
  CuentasPorPagarRoute: typeof CuentasPorPagarRoute
  DespachoRoute: typeof DespachoRouteWithChildren
  DocumentosRoute: typeof DocumentosRoute
  EmitirRoute: typeof EmitirRoute
  EmpleadoRoute: typeof EmpleadoRouteWithChildren
  EntregasRoute: typeof EntregasRoute
  GastosRoute: typeof GastosRoute
  ImportacionRoute: typeof ImportacionRoute
  InicioRoute: typeof InicioRoute
  InteligenciaArtificialRoute: typeof InteligenciaArtificialRoute
  NominaRoute: typeof NominaRoute
  PagosRoute: typeof PagosRoute
  ProductosRoute: typeof ProductosRoute
  RecibidosRoute: typeof RecibidosRoute
  ReportesRoute: typeof ReportesRoute
  SistemaRoute: typeof SistemaRouteWithChildren
  SuscripcionRoute: typeof SuscripcionRoute
  WebhooksRoute: typeof WebhooksRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activos-fijos': {
      id: '/activos-fijos'
      path: '/activos-fijos'
      fullPath: '/activos-fijos'
      preLoaderRoute: typeof ActivosFijosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bancos': {
      id: '/bancos'
      path: '/bancos'
      fullPath: '/bancos'
      preLoaderRoute: typeof BancosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clientes': {
      id: '/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof ClientesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compras': {
      id: '/compras'
      path: '/compras'
      fullPath: '/compras'
      preLoaderRoute: typeof ComprasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuracion': {
      id: '/configuracion'
      path: '/configuracion'
      fullPath: '/configuracion'
      preLoaderRoute: typeof ConfiguracionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consola': {
      id: '/consola'
      path: '/consola'
      fullPath: '/consola'
      preLoaderRoute: typeof ConsolaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contabilidad': {
      id: '/contabilidad'
      path: '/contabilidad'
      fullPath: '/contabilidad'
      preLoaderRoute: typeof ContabilidadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contador': {
      id: '/contador'
      path: '/contador'
      fullPath: '/contador'
      preLoaderRoute: typeof ContadorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cuentas-por-cobrar': {
      id: '/cuentas-por-cobrar'
      path: '/cuentas-por-cobrar'
      fullPath: '/cuentas-por-cobrar'
      preLoaderRoute: typeof CuentasPorCobrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cuentas-por-pagar': {
      id: '/cuentas-por-pagar'
      path: '/cuentas-por-pagar'
      fullPath: '/cuentas-por-pagar'
      preLoaderRoute: typeof CuentasPorPagarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/despacho': {
      id: '/despacho'
      path: '/despacho'
      fullPath: '/despacho'
      preLoaderRoute: typeof DespachoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentos': {
      id: '/documentos'
      path: '/documentos'
      fullPath: '/documentos'
      preLoaderRoute: typeof DocumentosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emitir': {
      id: '/emitir'
      path: '/emitir'
      fullPath: '/emitir'
      preLoaderRoute: typeof EmitirRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/empleado': {
      id: '/empleado'
      path: '/empleado'
      fullPath: '/empleado'
      preLoaderRoute: typeof EmpleadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entregas': {
      id: '/entregas'
      path: '/entregas'
      fullPath: '/entregas'
      preLoaderRoute: typeof EntregasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gastos': {
      id: '/gastos'
      path: '/gastos'
      fullPath: '/gastos'
      preLoaderRoute: typeof GastosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/importacion': {
      id: '/importacion'
      path: '/importacion'
      fullPath: '/importacion'
      preLoaderRoute: typeof ImportacionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inicio': {
      id: '/inicio'
      path: '/inicio'
      fullPath: '/inicio'
      preLoaderRoute: typeof InicioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inteligencia-artificial': {
      id: '/inteligencia-artificial'
      path: '/inteligencia-artificial'
      fullPath: '/inteligencia-artificial'
      preLoaderRoute: typeof InteligenciaArtificialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nomina': {
      id: '/nomina'
      path: '/nomina'
      fullPath: '/nomina'
      preLoaderRoute: typeof NominaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pagos': {
      id: '/pagos'
      path: '/pagos'
      fullPath: '/pagos'
      preLoaderRoute: typeof PagosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/productos': {
      id: '/productos'
      path: '/productos'
      fullPath: '/productos'
      preLoaderRoute: typeof ProductosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recibidos': {
      id: '/recibidos'
      path: '/recibidos'
      fullPath: '/recibidos'
      preLoaderRoute: typeof RecibidosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reportes': {
      id: '/reportes'
      path: '/reportes'
      fullPath: '/reportes'
      preLoaderRoute: typeof ReportesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sistema': {
      id: '/sistema'
      path: '/sistema'
      fullPath: '/sistema'
      preLoaderRoute: typeof SistemaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suscripcion': {
      id: '/suscripcion'
      path: '/suscripcion'
      fullPath: '/suscripcion'
      preLoaderRoute: typeof SuscripcionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks': {
      id: '/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof WebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consola/': {
      id: '/consola/'
      path: '/'
      fullPath: '/consola/'
      preLoaderRoute: typeof ConsolaIndexRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/auditoria': {
      id: '/consola/auditoria'
      path: '/auditoria'
      fullPath: '/consola/auditoria'
      preLoaderRoute: typeof ConsolaAuditoriaRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/entrar': {
      id: '/consola/entrar'
      path: '/entrar'
      fullPath: '/consola/entrar'
      preLoaderRoute: typeof ConsolaEntrarRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/fallidos': {
      id: '/consola/fallidos'
      path: '/fallidos'
      fullPath: '/consola/fallidos'
      preLoaderRoute: typeof ConsolaFallidosRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/morosos': {
      id: '/consola/morosos'
      path: '/morosos'
      fullPath: '/consola/morosos'
      preLoaderRoute: typeof ConsolaMorososRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/despacho/': {
      id: '/despacho/'
      path: '/'
      fullPath: '/despacho/'
      preLoaderRoute: typeof DespachoIndexRouteImport
      parentRoute: typeof DespachoRoute
    }
    '/despacho/auditoria': {
      id: '/despacho/auditoria'
      path: '/auditoria'
      fullPath: '/despacho/auditoria'
      preLoaderRoute: typeof DespachoAuditoriaRouteImport
      parentRoute: typeof DespachoRoute
    }
    '/despacho/clientes': {
      id: '/despacho/clientes'
      path: '/clientes'
      fullPath: '/despacho/clientes'
      preLoaderRoute: typeof DespachoClientesRouteImport
      parentRoute: typeof DespachoRoute
    }
    '/despacho/cuenta': {
      id: '/despacho/cuenta'
      path: '/cuenta'
      fullPath: '/despacho/cuenta'
      preLoaderRoute: typeof DespachoCuentaRouteImport
      parentRoute: typeof DespachoRoute
    }
    '/despacho/equipo': {
      id: '/despacho/equipo'
      path: '/equipo'
      fullPath: '/despacho/equipo'
      preLoaderRoute: typeof DespachoEquipoRouteImport
      parentRoute: typeof DespachoRoute
    }
    '/empleado/': {
      id: '/empleado/'
      path: '/'
      fullPath: '/empleado/'
      preLoaderRoute: typeof EmpleadoIndexRouteImport
      parentRoute: typeof EmpleadoRoute
    }
    '/empleado/acceso': {
      id: '/empleado/acceso'
      path: '/acceso'
      fullPath: '/empleado/acceso'
      preLoaderRoute: typeof EmpleadoAccesoRouteImport
      parentRoute: typeof EmpleadoRoute
    }
    '/sistema/': {
      id: '/sistema/'
      path: '/'
      fullPath: '/sistema/'
      preLoaderRoute: typeof SistemaIndexRouteImport
      parentRoute: typeof SistemaRoute
    }
    '/sistema/formularios': {
      id: '/sistema/formularios'
      path: '/formularios'
      fullPath: '/sistema/formularios'
      preLoaderRoute: typeof SistemaFormulariosRouteImport
      parentRoute: typeof SistemaRoute
    }
    '/sistema/retroalimentacion': {
      id: '/sistema/retroalimentacion'
      path: '/retroalimentacion'
      fullPath: '/sistema/retroalimentacion'
      preLoaderRoute: typeof SistemaRetroalimentacionRouteImport
      parentRoute: typeof SistemaRoute
    }
    '/sistema/superposiciones': {
      id: '/sistema/superposiciones'
      path: '/superposiciones'
      fullPath: '/sistema/superposiciones'
      preLoaderRoute: typeof SistemaSuperposicionesRouteImport
      parentRoute: typeof SistemaRoute
    }
    '/sistema/tabla': {
      id: '/sistema/tabla'
      path: '/tabla'
      fullPath: '/sistema/tabla'
      preLoaderRoute: typeof SistemaTablaRouteImport
      parentRoute: typeof SistemaRoute
    }
    '/consola/clientes/': {
      id: '/consola/clientes/'
      path: '/clientes'
      fullPath: '/consola/clientes/'
      preLoaderRoute: typeof ConsolaClientesIndexRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/clientes/$id': {
      id: '/consola/clientes/$id'
      path: '/clientes/$id'
      fullPath: '/consola/clientes/$id'
      preLoaderRoute: typeof ConsolaClientesIdRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/despachos/': {
      id: '/consola/despachos/'
      path: '/despachos'
      fullPath: '/consola/despachos/'
      preLoaderRoute: typeof ConsolaDespachosIndexRouteImport
      parentRoute: typeof ConsolaRoute
    }
    '/consola/despachos/$id': {
      id: '/consola/despachos/$id'
      path: '/despachos/$id'
      fullPath: '/consola/despachos/$id'
      preLoaderRoute: typeof ConsolaDespachosIdRouteImport
      parentRoute: typeof ConsolaRoute
    }
  }
}

interface ConsolaRouteChildren {
  ConsolaAuditoriaRoute: typeof ConsolaAuditoriaRoute
  ConsolaEntrarRoute: typeof ConsolaEntrarRoute
  ConsolaFallidosRoute: typeof ConsolaFallidosRoute
  ConsolaMorososRoute: typeof ConsolaMorososRoute
  ConsolaIndexRoute: typeof ConsolaIndexRoute
  ConsolaClientesIdRoute: typeof ConsolaClientesIdRoute
  ConsolaDespachosIdRoute: typeof ConsolaDespachosIdRoute
  ConsolaClientesIndexRoute: typeof ConsolaClientesIndexRoute
  ConsolaDespachosIndexRoute: typeof ConsolaDespachosIndexRoute
}

const ConsolaRouteChildren: ConsolaRouteChildren = {
  ConsolaAuditoriaRoute: ConsolaAuditoriaRoute,
  ConsolaEntrarRoute: ConsolaEntrarRoute,
  ConsolaFallidosRoute: ConsolaFallidosRoute,
  ConsolaMorososRoute: ConsolaMorososRoute,
  ConsolaIndexRoute: ConsolaIndexRoute,
  ConsolaClientesIdRoute: ConsolaClientesIdRoute,
  ConsolaDespachosIdRoute: ConsolaDespachosIdRoute,
  ConsolaClientesIndexRoute: ConsolaClientesIndexRoute,
  ConsolaDespachosIndexRoute: ConsolaDespachosIndexRoute,
}

const ConsolaRouteWithChildren =
  ConsolaRoute._addFileChildren(ConsolaRouteChildren)

interface DespachoRouteChildren {
  DespachoAuditoriaRoute: typeof DespachoAuditoriaRoute
  DespachoClientesRoute: typeof DespachoClientesRoute
  DespachoCuentaRoute: typeof DespachoCuentaRoute
  DespachoEquipoRoute: typeof DespachoEquipoRoute
  DespachoIndexRoute: typeof DespachoIndexRoute
}

const DespachoRouteChildren: DespachoRouteChildren = {
  DespachoAuditoriaRoute: DespachoAuditoriaRoute,
  DespachoClientesRoute: DespachoClientesRoute,
  DespachoCuentaRoute: DespachoCuentaRoute,
  DespachoEquipoRoute: DespachoEquipoRoute,
  DespachoIndexRoute: DespachoIndexRoute,
}

const DespachoRouteWithChildren = DespachoRoute._addFileChildren(
  DespachoRouteChildren,
)

interface EmpleadoRouteChildren {
  EmpleadoAccesoRoute: typeof EmpleadoAccesoRoute
  EmpleadoIndexRoute: typeof EmpleadoIndexRoute
}

const EmpleadoRouteChildren: EmpleadoRouteChildren = {
  EmpleadoAccesoRoute: EmpleadoAccesoRoute,
  EmpleadoIndexRoute: EmpleadoIndexRoute,
}

const EmpleadoRouteWithChildren = EmpleadoRoute._addFileChildren(
  EmpleadoRouteChildren,
)

interface SistemaRouteChildren {
  SistemaFormulariosRoute: typeof SistemaFormulariosRoute
  SistemaRetroalimentacionRoute: typeof SistemaRetroalimentacionRoute
  SistemaSuperposicionesRoute: typeof SistemaSuperposicionesRoute
  SistemaTablaRoute: typeof SistemaTablaRoute
  SistemaIndexRoute: typeof SistemaIndexRoute
}

const SistemaRouteChildren: SistemaRouteChildren = {
  SistemaFormulariosRoute: SistemaFormulariosRoute,
  SistemaRetroalimentacionRoute: SistemaRetroalimentacionRoute,
  SistemaSuperposicionesRoute: SistemaSuperposicionesRoute,
  SistemaTablaRoute: SistemaTablaRoute,
  SistemaIndexRoute: SistemaIndexRoute,
}

const SistemaRouteWithChildren =
  SistemaRoute._addFileChildren(SistemaRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivosFijosRoute: ActivosFijosRoute,
  BancosRoute: BancosRoute,
  ClientesRoute: ClientesRoute,
  ComprasRoute: ComprasRoute,
  ConfiguracionRoute: ConfiguracionRoute,
  ConsolaRoute: ConsolaRouteWithChildren,
  ContabilidadRoute: ContabilidadRoute,
  ContadorRoute: ContadorRoute,
  CuentasPorCobrarRoute: CuentasPorCobrarRoute,
  CuentasPorPagarRoute: CuentasPorPagarRoute,
  DespachoRoute: DespachoRouteWithChildren,
  DocumentosRoute: DocumentosRoute,
  EmitirRoute: EmitirRoute,
  EmpleadoRoute: EmpleadoRouteWithChildren,
  EntregasRoute: EntregasRoute,
  GastosRoute: GastosRoute,
  ImportacionRoute: ImportacionRoute,
  InicioRoute: InicioRoute,
  InteligenciaArtificialRoute: InteligenciaArtificialRoute,
  NominaRoute: NominaRoute,
  PagosRoute: PagosRoute,
  ProductosRoute: ProductosRoute,
  RecibidosRoute: RecibidosRoute,
  ReportesRoute: ReportesRoute,
  SistemaRoute: SistemaRouteWithChildren,
  SuscripcionRoute: SuscripcionRoute,
  WebhooksRoute: WebhooksRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
